import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ContentPostList.css';

// Reusable list for News/Articles, distinguished by which service + basePath is passed in.
const ContentPostList = ({ service, basePath }) => {
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        setError(null);
        service.getList(page)
            .then(({ data }) => {
                setItems(data.items);
                setTotalPages(data.totalPages);
            })
            .catch(() => setError('Не удалось загрузить материалы.'))
            .finally(() => setLoading(false));
    }, [service, page]);

    if (loading) return <div className="content-list__placeholder">Загрузка...</div>;
    if (error) return <div className="content-list__placeholder">{error}</div>;
    if (items.length === 0) return <div className="content-list__placeholder">Пока ничего нет.</div>;

    return (
        <>
            <div className="content-list__grid">
                {items.map((item) => (
                    <Link key={item.id} to={`${basePath}/${item.slug}`} className="content-list__card">
                        {item.coverImageUrl ? (
                            <img src={item.coverImageUrl} alt={item.title} className="content-list__cover" />
                        ) : (
                            <div className="content-list__cover content-list__cover--placeholder" />
                        )}
                        <div className="content-list__body">
                            {item.publishedAt && (
                                <div className="content-list__date">
                                    {new Date(item.publishedAt).toLocaleDateString('ru-RU')}
                                </div>
                            )}
                            <h3 className="content-list__title">{item.title}</h3>
                            {item.summary && <p className="content-list__summary">{item.summary}</p>}
                        </div>
                    </Link>
                ))}
            </div>

            {totalPages > 1 && (
                <div className="content-list__pagination">
                    <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>Назад</button>
                    <span>{page} / {totalPages}</span>
                    <button disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)}>Далее</button>
                </div>
            )}
        </>
    );
};

export default ContentPostList;
